import React from 'react';
import clsx from 'clsx';

import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	getVirtualizedListScrollBorderClass,
	virtualizedListScrollBorderClasses,
	VirtualizedListScrollBorderClasses,
} from './virtualizedListScrollBorderClasses';

type VirtualizedListScrollBorderUtilityClassProps = WithClasses<
	VirtualizedListScrollBorderClasses,
	{
		active?: boolean;
		scrolled?: boolean;
		scrollEnd?: boolean;
	}
>;

const useUtilityClasses = (
	ownerState: VirtualizedListScrollBorderUtilityClassProps,
) => {
	const {classes, active, scrollEnd, scrolled} = ownerState;

	const slots = {
		root: [
			'root',
			active && 'active',
			scrollEnd && 'scrollEnd',
			scrolled && 'scrolled',
		],
	};

	return composeClasses(slots, getVirtualizedListScrollBorderClass, classes);
};

const VirtualizedListScrollBorderRoot = styled('div', {
	name: 'VirtualizedList',
	slot: 'Root',
})(({theme}) => ({
	bottom: 0,
	left: 0,
	pointerEvents: 'none',
	position: 'absolute',
	top: 0,
	width: '100%',
	zIndex: 5,
	border: `1px solid transparent`,
	borderLeft: 0,
	borderRight: 0,
	[`&.${virtualizedListScrollBorderClasses.active}`]: {
		[`&.${virtualizedListScrollBorderClasses.scrolled}`]: {
			borderTopColor: theme.palette.custom.border,
		},
		[`&:not(.${virtualizedListScrollBorderClasses.scrollEnd})`]: {
			borderBottomColor: theme.palette.custom.border,
		},
	},
}));

export interface VirtualizedListScrollBorderProps
	extends WithClasses<
		VirtualizedListScrollBorderClasses,
		{
			scrolled: boolean;
			active: boolean;
			scrollEnd: boolean;
		}
	> {}

export const VirtualizedListScrollBorderPrimitive = ({
	className,
	...props
}: VirtualizedListScrollBorderProps) => {
	const classes = useUtilityClasses(props);

	return (
		<VirtualizedListScrollBorderRoot
			className={clsx(classes.root, className)}
		/>
	);
};

export const VirtualizedListScrollBorder = React.memo(
	VirtualizedListScrollBorderPrimitive,
);

export default VirtualizedListScrollBorder;
